import dayjs from "dayjs";
import { SERVICES } from "../shared/tagTypes";
import { baseApi } from "./base";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const serviceApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [SERVICES],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getMyBookedServices: builder.query({
                query: (payload) => ({
                    url: "/serial-no/my-booked-services",
                    params: {
                        date: dayjs().format("YYYY-MM-DDTHH:mm:ss")
                    }
                }),
                providesTags: [SERVICES],
            }),
            getMyServices: builder.query({
                query: (payload) => ({
                    url: "/serial-no/my-services",
                    params: {
                        pageSize: payload.pageSize,
                        pageNo: payload.pageNo,
                        ...(payload.serviceDate && { startDate: payload.serviceDate, endDate: payload.serviceDate }),
                        ...(payload.serviceCenterId && { serviceCenterId: payload.serviceCenterId })
                    }
                }),
                providesTags: [SERVICES],
            }),
            getServices: builder.query({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/services`,
                    params: {
                        date: payload.serviceDate
                    }
                }),
                providesTags: [SERVICES],
            }),
            bookService: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/services/book`,
                    method: "POST",
                    body: payload.body
                }),
                invalidatesTags: [SERVICES],
            }),
            updateService: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/services/${payload.id}`,
                    method: "PUT",
                    body: payload.body
                }),
                invalidatesTags: [SERVICES],
            }),
            updateNextServices: builder.mutation({
                query: (payload) => ({
                    url: `/serial-no/service-centers/${payload.serviceCenterId}/services/next`,
                    method: "POST",
                    body: payload.body
                }),
                invalidatesTags: [SERVICES],
            }),
        }),

        overrideExisting: false,
    });

export const {
    useGetMyBookedServicesQuery,
    useLazyGetMyBookedServicesQuery,
    useGetMyServicesQuery,
    useLazyGetMyServicesQuery,
    useGetServicesQuery,
    useLazyGetServicesQuery,
    useBookServiceMutation,
    useUpdateServiceMutation,
    useUpdateNextServicesMutation
} = serviceApi;
